import Account from './components/Account';
import MarketPlace from "./components/MarketPlace";

import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Account/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/market_place`}>
				<MarketPlace/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
